import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiGift, FiSearch, FiMessageCircle } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const internalLinks = [
    { name: 'Início', path: '/' },
    { name: 'Sobre', path: '/sobre' },
    { name: 'Espaço', path: '/nosso-espaco' },
    { name: 'Serviços', path: '/servicos' },
    { name: 'Quiz Pet', path: 'https://quiz.unipet.online/', isExternal: true },
    { name: 'Contato', path: '/contato' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center group">
            <img src="https://i.imgur.com/LJ9Fcbk.png" alt="UniPET Logo" className="h-10 w-auto" />
          </Link>

          <div className="hidden lg:flex items-center space-x-6">
            <div className="flex items-center space-x-5 border-r border-gray-100 pr-5">
              {internalLinks.map((item) => (
                item.isExternal ? (
                  <a 
                    key={item.name} 
                    href={item.path} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[13px] font-bold text-blue-600 hover:text-blue-900 transition-colors flex items-center gap-1"
                  >
                    <SafeIcon icon={FiSearch} className="w-3.5 h-3.5" />
                    {item.name}
                  </a>
                ) : (
                  <Link 
                    key={item.name} 
                    to={item.path} 
                    className={`text-[13px] font-bold transition-colors ${isActive(item.path) ? 'text-blue-900' : 'text-gray-500 hover:text-blue-900'}`}
                  >
                    {item.name}
                  </Link>
                )
              ))}
            </div>
            
            <div className="flex items-center space-x-3">
              <Link to="/cupons" className="flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-xl font-bold text-xs border border-orange-100 hover:bg-orange-100 transition-all">
                <SafeIcon icon={FiGift} /> 15% OFF
              </Link>
              <a href="https://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" className="bg-blue-900 text-white px-5 py-2.5 rounded-xl font-bold text-xs shadow-lg shadow-blue-900/10 hover:bg-blue-950 transition-all flex items-center gap-2">
                <SafeIcon icon={FiMessageCircle} /> Contato
              </a>
            </div>
          </div>

          <div className="lg:hidden">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-gray-600">
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>

        <AnimatePresence>
          {isMenuOpen && (
            <motion.div 
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden border-t border-gray-100 bg-white"
            >
              <div className="py-4 space-y-1">
                {internalLinks.map((item) => (
                  item.isExternal ? (
                    <a 
                      key={item.name} 
                      href={item.path}
                      onClick={() => setIsMenuOpen(false)}
                      className="block px-4 py-3 text-base font-bold text-blue-600"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <Link 
                      key={item.name} 
                      to={item.path} 
                      onClick={() => setIsMenuOpen(false)}
                      className="block px-4 py-3 text-base font-bold text-gray-700"
                    >
                      {item.name}
                    </Link>
                  )
                ))}
                <div className="px-4 py-4 grid grid-cols-2 gap-3">
                  <Link to="/cupons" onClick={() => setIsMenuOpen(false)} className="bg-orange-500 text-white p-4 rounded-xl font-bold text-center text-sm">
                    Cupons
                  </Link>
                  <a href="https://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="bg-blue-900 text-white p-4 rounded-xl font-bold text-center text-sm">
                    WhatsApp
                  </a>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Header;